<div
  class="view-page-banner"
  [class.info]="status === 'info'"
  [class.warning]="status === 'warning'"
  [class.error]="status === 'error'"
  data-testid="banner"
>
  @if (status === 'warning') {
    <capra-status-icon status="warning" class="icon"></capra-status-icon>
  } @else if (status === 'error') {
    <capra-icon [icon]="'icon-warning'" class="icon" data-testid="error-icon"></capra-icon>
  }
  <ng-content></ng-content>
</div>
